export default "/Frontend/dist/pdf.3a4521e2251d96f054d294ec85ca224c.svg";